<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :append-to-body="true" :close-on-click-modal="false" width="60%" :visible.sync="viewData.visible">
    <!-- 定点申请类别 设变 寻源申请 样件 其他 与李亮坤确认-->
    <!-- 添加招标工作计划 -->
    <!-- QA：通知模板样例 -->
    <div>
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form">
            <el-tabs>
                <el-tab-pane class="tab_style" :key="1" label="基础信息" style="min-height: 42vh;">
                    <div class="des_box mb15">
                        <el-descriptions class="margin-top" :column="2" size="small" border>
                            <el-descriptions-item label="项目:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="projectManagerName" size="small">
                                    {{ projectName }}&nbsp;&nbsp;<el-button v-if="viewFlag !== 'view' && dataForm.technicalStatus === '0'" size="small" @click="selectProject()">
                                        选择项目
                                    </el-button>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="车型:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="carType" size="small">
                                    <el-input v-if="viewFlag !== 'view' && !dataForm.id" size="small" v-model="dataForm.carType" placeholder="车型" clearable>
                                    </el-input>
                                    <span v-else>{{dataForm.carType}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="定点申请编码:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="technicalCode" size="small">
                                    {{dataForm.technicalCode}}
                                    <!-- <span v-if="viewFlag === 'view'">{{dataForm.technicalCode}}</span> -->
                                    <!-- <el-input v-else size="small" v-model="dataForm.technicalCode" clearable placeholder="定点申请编码">
                                </el-input> -->
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="定点申请主题:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="technicalName" size="small">
                                    <el-input v-if="viewFlag !== 'view' && dataForm.technicalStatus === '0'" size="small" v-model="dataForm.technicalName" placeholder="定点申请主题" clearable>
                                    </el-input>
                                    <span v-else>{{dataForm.technicalName}}</span>
                                </el-form-item>
                            </el-descriptions-item>

                            <el-descriptions-item label="定点申请类型:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="technicalType">
                                    <el-select v-if="viewFlag !== 'view' && dataForm.technicalStatus === '0'" size="small" v-model="dataForm.technicalType" placeholder="请选择类型" clearable>
                                        <el-option v-for="item in TECHNICAL_NOTIFICATION_TYPE" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <span v-else>{{getTechnicalValue(dataForm.technicalType)}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="定点申请状态" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="technicalStatus">
                                    {{getTechnicalStatusValue(dataForm.technicalStatus)}}
                                </el-form-item>
                            </el-descriptions-item>
                            <template v-if="dataForm.technicalType === '0'">

                                <el-descriptions-item label="寻源申请类型:" :label-style="getStyle()" :content-style="getStyle2()">
                                    <el-radio-group v-if="viewFlag !== 'view'" v-model="dataForm.sourceType" size="mini">
                                        <el-radio-button label="招标"></el-radio-button>
                                        <el-radio-button label="议标"></el-radio-button>
                                    </el-radio-group>
                                    <span v-else>{{sourceTypeFormat(dataForm.sourceType)}}</span>
                                </el-descriptions-item>

                                <el-descriptions-item :label-style="getStyle()" :content-style="getStyle2()">
                                </el-descriptions-item>

                                <!-- <el-descriptions-item label="委会联系人:" :label-style="getStyle()" :content-style="getStyle2()">
                                    <el-form-item style="margin-bottom: 0;" prop="committeeContact" size="small">
                                        <span>{{dataForm.committeeContact}}</span>&nbsp;&nbsp;
                                        <el-button v-if="viewFlag !== 'view' && !dataForm.id" size="small" plain type="primary" @click="chooseCommitteeContact()">
                                            选择
                                        </el-button>
                                    </el-form-item>
                                </el-descriptions-item>

                                <el-descriptions-item label="联系方式:" :label-style="getStyle()" :content-style="getStyle2()">
                                    <el-form-item style="margin-bottom: 0;" prop="contact" size="small">
                                        <el-input v-if="viewFlag !== 'view' && !dataForm.id" size="small" v-model="dataForm.contact" placeholder="联系方式" clearable>
                                        </el-input>
                                        <span v-else>{{dataForm.contact}}</span>
                                    </el-form-item>
                                </el-descriptions-item> -->

                            </template>

                            <el-descriptions-item label="定点申请描述" :label-style="getStyle()">
                                <el-form-item style="margin-bottom: 0;" prop="remark" size="small">
                                    <el-input v-if="viewFlag !== 'view' && dataForm.technicalStatus === '0'" type="textarea" v-model="dataForm.remark" :rows="2" placeholder="定点申请描述" clearable>
                                    </el-input>
                                    <span v-else>{{dataForm.remark}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                    <span style="position:absolute; right:0; bottom:0;">
                        <el-button size="small" @click="viewData.visible = false">
                            取消
                        </el-button>
                        <el-button v-if="isAuth('sourcing:requirement:newbutton') && viewFlag !== 'view' && dataForm.technicalStatus !='1'" size="small" type="primary" plain @click="dataFormSubmit()" :loading="loading">
                            保存
                        </el-button>
                        <el-button v-if="isAuth('sourcing:requirement:newbutton') && (viewFlag !== 'view'||this.confirm === 'confirm') && dataForm.technicalStatus !='1'" size="small" type="success" plain :disabled="partList && partList.length === 0" @click="dataFormPublish()" :loading="loading">
                            发布
                        </el-button>
                    </span>
                </el-tab-pane>
                <el-tab-pane class="tab_style" :key="2" label="零件清单">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-button size="small" v-if="isAuth('sourcing:requirement:newbutton') && viewFlag !== 'view'" type="primary" plain @click="selectPartList()" icon="el-icon-plus" :disabled="!dataForm.id" class="mb15 fr">
                                选择零件
                            </el-button>

                            <el-upload class="file" v-if="isAuth('sourcing:requirement:newbutton') && viewFlag !== 'view'" action :show-file-list="false" :on-success="handleFileSuccess" :http-request="UploadSubmit" style="float:right;padding-right:5px">
                                <!-- <el-button slot="trigger" size="small" type="primary" icon="el-icon-plus">导入零件</el-button> -->
                            </el-upload>
                            <el-table :data="partList" :row-style="getRowStyle" row-key="id" size="small" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }" class="mb15">
                                <el-table-column type="index" width="50" label="序号">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="partCode" width="150" header-align="center" align="left" label="零件编号">
                                </el-table-column>
                                <el-table-column prop="partName" width="160" header-align="center" align="left" label="零件名称">
                                </el-table-column>
                              <el-table-column prop="cancelFlag" width="160" header-align="center" align="left" label="取消标识">
                                <template slot-scope="scope">
                                  <span>{{ scope.row.cancelFlag === 1 ? '是' : "否" }}</span>
                                </template>
                              </el-table-column>
                                <el-table-column prop="oneCarCount" width="70" header-align="center" align="center" label="单车用量">
                                </el-table-column>
                                <el-table-column prop="unit" width="70" header-align="center" align="center" label="单位">
                                </el-table-column>
                                <el-table-column prop="supplyStatus" header-align="center" align="center" label="建议货源" width="80">
                                    <template slot-scope="scope">
                                        <span>{{supplyStatusFormat(scope.row.supplyStatus)}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="targetPrice" header-align="center" align="center" label="目标价格">
                                </el-table-column>
                                <el-table-column prop="targetInvestment" header-align="center" width="90" align="center" label="目标工装费">
                                </el-table-column>
                                <el-table-column prop="targetDevelopment" header-align="center" width="90" align="center" label="目标开发费">
                                </el-table-column>
                                <el-table-column prop="targetTestfee" header-align="center" width="90" align="center" label="目标试验费">
                                </el-table-column>
                                <el-table-column v-if="isAuth('sourcing:requirement:newbutton') && viewFlag !== 'view'" header-align="center" align="left" width="150" label="操作">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="taddOrUpdatePartHandle(scope.row.id)" icon="el-icon-edit">
                                            修改
                                        </el-button>
                                        <el-button type="text" size="small" class="button-danger" @click=" deleteHandlePart(scope.row.id)" icon="el-icon-delete">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- 分页 -->
                            <el-pagination class="fr" @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
                            </el-pagination>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane class="tab_style" :key="3" label="招标工作计划">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-button size="small" v-if="isAuth('sourcing:requirement:newbutton') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateBiddingHandle()" icon="el-icon-plus" :disabled="!dataForm.id" class="mb15 fr">
                                新增招标计划
                            </el-button>
                            <el-table :data="biddingList" row-key="id" size="small" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }" class="mb15">
                                <el-table-column type="index" width="50" label="序号">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="workContent" header-align="center" align="left" label="工作内容">
                                </el-table-column>
                                <el-table-column prop="chargeDept" header-align="center" align="left" label="责任部门">
                                </el-table-column>
                                <el-table-column prop="workDate" header-align="center" align="right" label="日期" width="170" :formatter="dateFormat">
                                </el-table-column>
                                <el-table-column v-if="isAuth('sourcing:requirement:newbutton') && viewFlag !== 'view'" header-align="center" align="left" width="150" label="操作">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="
                                                addOrUpdateBiddingHandle(
                                                    scope.row.id
                                                )
                                            " icon="el-icon-edit">
                                            修改
                                        </el-button>
                                        <el-button type="text" size="small" class="button-danger" @click="
                                                deleteHandleBidding(
                                                    scope.row.id
                                                )
                                            " icon="el-icon-delete">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- 分页 -->
                            <el-pagination class="fr" @size-change="sizeChangeHandleBidding" @current-change="currentChangeHandleBidding" :current-page="pageIndexBidding" :page-sizes="[10, 20, 50]" :page-size="pageSizeBidding" :total="totalPageBidding" layout="total, sizes, prev, pager, next, jumper">
                            </el-pagination>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane class="tab_style" :key="4" label="推荐供应商">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-button size="small" v-if="
                                    isAuth('sourcing:requirement:newbutton') &&
                                    viewFlag !== 'view'
                                " type="primary" @click="addOrUpdateSupplierHandle()" icon="el-icon-plus" plain :disabled="!dataForm.id" class="mb15 fr">
                                新增供应商
                            </el-button>
                            <el-table :data="supplierList" row-key="id" size="small" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }" class="mb15">
                                <el-table-column type="index" width="50" label="序号">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="recommendedSupplierName" header-align="center" align="left" label="推荐供应商名称">
                                </el-table-column>
                                <el-table-column prop="recommendedSupplierExpierence" header-align="center" align="left" label="项目经验">
                                </el-table-column>

                                <el-table-column prop="committeeContact" header-align="center"  align="left" label="联系人">
                                </el-table-column>
                                <el-table-column prop="contact" header-align="center" align="left" label="联系方式">
                                </el-table-column>
                                <el-table-column prop="remark" header-align="center" align="left" label="备注">
                                </el-table-column>
                                <el-table-column v-if="isAuth('sourcing:requirement:newbutton') && viewFlag !== 'view'" header-align="center" align="left" width="150" label="操作">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="
                                                addOrUpdateSupplierHandle(
                                                    scope.row.id
                                                )
                                            " icon="el-icon-edit">
                                            修改
                                        </el-button>
                                        <el-button type="text" size="small" class="button-danger" @click="
                                                deleteSupplierHandle(
                                                    scope.row.id
                                                )
                                            " icon="el-icon-delete">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- 分页 -->
                            <el-pagination class="fr" @size-change="sizeChangeHandleSupplierList" @current-change="
                                    currentChangeHandleSupplierList
                                " :current-page="pageIndexSupplierList" :page-sizes="[10, 20, 50]" :page-size="pageSizeSupplierList" :total="totalPageSupplierList" layout="total, sizes, prev, pager, next, jumper">
                            </el-pagination>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane class="tab_style" :key="4" label="审批历史">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-table :data="approveHistoryList" row-key="id" size="small" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }" class="mb15">
                                <el-table-column type="index" width="50" label="序号">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="technicalDepartment" width="160" header-align="center" align="left" label="审批部门">
                                </el-table-column>
                                <el-table-column prop="technicalApprover" width="100" header-align="center" align="left" label="审批人">
                                </el-table-column>

                                <el-table-column prop="technicalSuggstion" header-align="center" align="left" label="审批意见">
                                </el-table-column>
                                <el-table-column prop="technicalTime" width="160" header-align="center" align="left" label="审批时间">
                                </el-table-column>

                            </el-table>
                            <!-- 分页 -->
                            <el-pagination class="fr" @size-change="sizeChangeHandleSupplierList" @current-change="
                                    currentChangeHandleSupplierList
                                " :current-page="pageIndexSupplierList" :page-sizes="[10, 20, 50]" :page-size="pageSizeSupplierList" :total="totalPageSupplierList" layout="total, sizes, prev, pager, next, jumper">
                            </el-pagination>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane class="tab_style" :key="5" label="附件文件">
                    <FileUpDown ref="FileUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE" :uploadDate=true></FileUpDown>
                </el-tab-pane>
            </el-tabs>
        </el-form>
        <div>
            <!-- 弹窗, 新增 / 修改 零件-->
            <add-or-update-part v-if="taddOrUpdatePartVisible" ref="taddOrUpdatePart" @refreshPartDataList="getPartList"></add-or-update-part>
            <!-- 弹窗, 新增 / 修改 供应商-->
            <add-or-update-supplier v-if="addOrUpdateSupplierVisible" ref="addOrUpdateSupplier" @refreshSupplierDataList="getSupplierList"></add-or-update-supplier>
            <!-- 弹窗, 新增 / 修改 招标-->
            <add-or-update-bidding v-if="addOrUpdateBiddingVisible" ref="addOrUpdateBidding" @refreshBiddingDataList="getBiddingList"></add-or-update-bidding>
            <!-- 弹窗, 查询项目管理表-->
            <tech-get-project ref="addOrUpdateProject"></tech-get-project>
            <!-- 选择零件弹窗 -->
            <select-tech-part v-if="selectPartVisible" :partFormData="dataForm" ref="selectPart" @refreshPartDataList="getPartList"></select-tech-part>
            <!-- 选择委会联系人 -->
            <common-user-dialog ref="commonUserDialog"></common-user-dialog>
        </div>
    </div>
</el-dialog>
</template>

<script>
import {
    getPartList,
    getSupplierList,
    getBiddingList,
    getApprovalList,
    createTechNoti,
    editTechNoti,
    getTechNotiById,
    deletePart,
    deleteSupplier,
    deleteBidding,
    importFile
} from "@/controller/tech";
import moment from "moment";
import {
    USER_TYPE,
    DIALOG_CLOSED_TYPE,
    SUPPLY_STATUS,
    getLabelByValue,
    TECHNICAL_NOTIFICATION_TYPE,
    TECHNICAL_INFO_STATUS,
    getTechnicalStatusValue,
    getTechnicalValue,
    SOURCE_TYPE_VALUE,
} from "@/utils/const";
import {
    mapping
} from "@/utils";
import AddOrUpdatePart from "./part-add-or-update";
import AddOrUpdateSupplier from "./supplier-add-or-update";
import AddOrUpdateBidding from "./bidding-add-or-update";
import TechGetProject from "./tech-project-list";
import FileUpDown from "@/views/common/file-up-down";
import SelectTechPart from './select-tech-part';
import CommonUserDialog from "@/views/common/common-user-dialog";
import {
    setLoading
} from "@/utils/index";
export default {
    components: {
        AddOrUpdatePart,
        AddOrUpdateSupplier,
        AddOrUpdateBidding,
        CommonUserDialog,
        TechGetProject,
        FileUpDown, //上传附件
        SelectTechPart
    },
    props: {
        //零件列表数据
        partFormData: Object
    },
    data() {
        return {
            FILE_BIZ_TYPE: 10,
            viewFlag: "",
            confirm:'',
            viewData: {
                visible: false,
                width: "",
            },
            TECHNICAL_NOTIFICATION_TYPE: TECHNICAL_NOTIFICATION_TYPE,
            TECHNICAL_INFO_STATUS: TECHNICAL_INFO_STATUS,
            getTechnicalStatusValue: getTechnicalStatusValue,
            getTechnicalValue: getTechnicalValue,
            SOURCE_TYPE_VALUE: SOURCE_TYPE_VALUE,
            dataList: [],
            partList: [],
            loading: false,
            // 零件
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            // 供应商
            pageIndexSupplierList: 1,
            pageSizeSupplierList: 10,
            totalPageSupplierList: 0,
            pageIndexBidding: 1,
            pageSizeBidding: 10,
            totalPageBidding: 0,
            supplierList: [],
            biddingList: [],
            biddingPlans: [],
            approveHistoryList: [],
            taddOrUpdatePartVisible: false,
            addOrUpdateSupplierVisible: false,
            addOrUpdateBiddingVisible: false,
            techGetProjectVisible: false,
            selectPartVisible: false,
            projectName: '',
            dataForm: {
                id: 0,
                projectName: "",
                projectManagerName: "",
                technicalType: "",
                carType: "",
                remark: "",
                projectId: "",
                projectCode: "",
                technicalId: "",
                technicalCode: "",
                technicalName: "",
                projectManagerId: "",
                projectType: "",
                sourceType: "",
                committeeContact: "",
                contact: "",
                partCount: "",
                partSumCount: "",
                technicalStatus: "",
            },
            dataRule: {
                technicalType: [{
                    required: true,
                    message: "请选择类型",
                    trigger: "blur",
                }],
                projectManagerName: [{
                    required: true,
                    message: "请选择项目",
                    trigger: "blur",
                }],
                // remark: [{
                //     required: true,
                //     message: "请填写备注",
                //     trigger: "blur",
                // }],
            },
        };
    },
    mounted() {},
    methods: {
      getRowStyle({ row, rowIndex }) {
        if (row.cancelFlag === 1) {
          return { backgroundColor: '#f5f7fa' }; // 灰色背景
        }
        return {};
      },
        // 新增 / 修改 零件表
        taddOrUpdatePartHandle(id) {
            this.taddOrUpdatePartVisible = true;
            this.$nextTick(() => {
                this.$refs.taddOrUpdatePart.init(id, this.dataForm.id);
            });
        },
        // 新增 / 修改 供应商
        addOrUpdateSupplierHandle(id) {
            this.addOrUpdateSupplierVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdateSupplier.init(id, this.dataForm.id);
            });
        },
        // 新增 / 修改 招标
        addOrUpdateBiddingHandle(id) {
            this.addOrUpdateBiddingVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdateBidding.init(id, this.dataForm.id);
            });
        },
        // 选择项目
        selectProject() {
            const _this = this;
            this.$refs.addOrUpdateProject.open(USER_TYPE.MANAGER);
            this.$refs.addOrUpdateProject.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    mapping(payload.data, _this.dataForm, ["id"]);
                    _this.dataForm.projectId = payload.data.id;
                    _this.projectName = payload.data.projectName;
                }
            };
        },
        //选择零件
        selectPartList(id) {
            this.selectPartVisible = true;
            this.$nextTick(() => {
                // const _this = this
                const materialCodes = []
                this.partList.forEach(part => {
                    materialCodes.push(part.technicalId)
                });
                this.$refs.selectPart.open(materialCodes,this.partList);
                this.$refs.selectPart.onClosed = (payload) => {
                    if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                        this.getPartList()
                    }
                };
            });
        },
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY年MM月DD日");
        },
        // 初始化
        init(rec, viewFlag, confirm) {
            // init(data) {
            // console.log(data)
            // this.dataForm = id ? this.dataForm : this.data;
            // this.dataForm.id =0;
            console.log(this.partList.length)
            this.dataForm.technicalType = ''
            this.viewFlag = viewFlag;
            this.confirm = confirm;
            this.projectName = rec && rec.projectName || ''
            this.dataForm.id = rec && rec.id || null
            this.dataForm.technicalStatus = this.dataForm.technicalStatus || '0'
            this.partList = [];
            this.supplierList = [];
            this.biddingList = [];
            this.approveHistoryList = []
            this.dataForm.remark = ''
            this.viewData.visible = true;
            this.loading = false;
            this.$nextTick(() => {

                this.$refs.FileUpDown.init(this.viewFlag);
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id找通知对象
                    getTechNotiById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                    // 调用查询零件 供应商 招标 的List查询方法
                    this.getPartList()
                    this.getSupplierList()
                    this.getBiddingList()
                    this.getApprovalList()
                    // this.getBiddingTemplateList()
                }
            });
        },
        // 零件的分页方法
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getPartList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getPartList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        supplyStatusFormat: function (value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(SUPPLY_STATUS, value);
        },
        typeFormat: function (value) {
            // debugger;
            if (!value) {
                return "";
            }
            return getLabelByValue(TECHNICAL_NOTIFICATION_TYPE, value);
        },
        sourceTypeFormat: function (value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(SOURCE_TYPE_VALUE, value);
        },
        // 查所有零件表
        getPartList() {
            getPartList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                technicalId: this.dataForm.id,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.partList = data.body.records;
                    this.totalPage = data.body.total;
                    console.log(this.partList)
                } else {
                    this.partList = [];
                    this.totalPage = 0;
                }
            });
        },
        // 供应商的分页方法
        // 每页数
        sizeChangeHandleSupplierList(val) {
            this.pageSizeSupplierList = val;
            this.pageIndexSupplierList = 1;
            this.getSupplierList();
        },
        // 当前页
        currentChangeHandleSupplierList(val) {
            this.pageIndexSupplierList = val;
            this.getSupplierList();
        },
        // 多选
        selectionChangeHandleSupplierList(val) {
            this.dataListSelections = val;
        },
        // 查所有供应商表
        getSupplierList() {
            getSupplierList({
                pageNo: this.pageIndexSupplierList,
                pageSize: this.pageSizeSupplierList,
                technicalId: this.dataForm.id,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.supplierList = data.body.records;
                    this.totalPageSupplierList = data.body.total;
                } else {
                    this.supplierList = [];
                    this.totalPageSupplierList = 0;
                }
            });
        },
        // 查所有审批历史
        getApprovalList() {
            getApprovalList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                technicalId: this.dataForm.id,
            }).then((data) => {
               if (data && data.code === "00") {
                  this.approveHistoryList = data.body.records;
                  this.totalPage = data.body.total;
                  console.log(this.approveHistoryList)
               } else {
                  this.approveHistoryList = [];
                  this.totalPage = 0;
               }
            });
        },
        // 招标的分页方法
        // 每页数
        sizeChangeHandleBidding(val) {
            this.pageSizeBidding = val;
            this.pageIndexBidding = 1;
            this.getBiddingList();
        },
        // 当前页
        currentChangeHandleBidding(val) {
            this.pageIndexBidding = val;
            this.getBiddingList();
        },
        // 多选
        selectionChangeHandleBidding(val) {
            this.dataListSelections = val;
        },
        // 查所有招标表
        getBiddingList() {
            getBiddingList({
                pageNo: this.pageIndexBidding,
                pageSize: this.pageSizeBidding,
                technicalId: this.dataForm.id,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.biddingList = data.body.records;
                    this.totalPageBidding = data.body.total;
                } else {
                    this.biddingList = [];
                    this.totalPageBidding = 0;
                }
            });
        },
        // // 查所有招标模板表
        // getBiddingTemplateList() {
        //     getBiddingTemplateList({
        //         pageNo: this.pageIndexBidding,
        //         pageSize: this.pageSizeBidding,
        //         technicalId: this.dataForm.id,
        //     }).then((data) => {
        //         if (data && data.code === "00") {
        //             this.biddingPlans = data.body.records;
        //             // this.totalPageBidding = data.body.total;
        //         } else {
        //             this.biddingList = [];
        //             this.totalPageBidding = 0;
        //         }
        //     });
        // },
        dataFormPublish() {
            if(this.dataForm.technicalStatus = '0'){
                this.dataForm.technicalStatus = '1'
            }
             this.dataFormSubmit()
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    this.loading = true
                    if (this.dataForm.id) {
                        editTechNoti(this.dataForm)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "定点申请修改成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.viewData.visible = false;
                                            this.$emit("refreshDataList");
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        createTechNoti(this.dataForm)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.dataForm = data.body;
                                    this.$message({
                                        message: "定点申请创建成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.loading = false;
                                            this.getBiddingList();
                                            this.$emit("refreshDataList");
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        // 删除零件
        deleteHandlePart(id) {
            let ids = id ? [id] :
                this.dataListSelections.map((item) => {
                    return item.id;
                });
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    deletePart(ids)
                        .then((data) => {
                            // deleteTech([id]).then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getPartList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        // 删除供应商
        deleteSupplierHandle(id) {
            let ids = id ? [id] :
                this.dataListSelections.map((item) => {
                    return item.id;
                });
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    deleteSupplier(ids)
                        .then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getSupplierList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        // 删除招标
        deleteHandleBidding(id) {
            let ids = id ? [id] :
                this.dataListSelections.map((item) => {
                    return item.id;
                });
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    deleteBidding(ids)
                        .then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getBiddingList();
                                        // this.$emit("refreshDataList");
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        UploadSubmit(param) {
            //console.log(param.file);
            var file = param.file;
            var file_form = new FormData(); //获取上传表单（文件）
            file_form.append("file", file);
            file_form.append("technicalId", this.dataForm.id);
            importFile(file_form).then(data => {
                if (data && data.code === '00') {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            this.getDataList()
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            });
        },
        //   选择委会联系人
        chooseCommitteeContact() {
            this.$refs.commonUserDialog.open(USER_TYPE.PERCHASE)
            this.$refs.commonUserDialog.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    // this.dataForm.partybCode = ''
                    this.dataForm.committeeContactId = payload.data.defaultPositionId
                    this.dataForm.committeeContact = payload.data.realName
                }
            };
        },
        // submitUpload() {
        //     this.$refs.upload.submit();
        // },
        // handleRemove(file, fileList) {
        //     console.log(file, fileList);
        // },
        // handlePreview(file) {
        //     console.log(file);
        // },
        // 文件-图片-上传成功返回内容
        handleFileSuccess(res) {
            if (res) {
                let arr = {
                    type: this.type,
                    data: res.data
                };
                // 抛出的数据内容
                this.$emit("handleSuccess", arr);
                this.$message.success("上传成功！");
            }
        },
        // // 文件-图片-上传操作
        // uploadLicencePicNo(param) {
        //     var file = param.file;
        //     var file_form = new FormData(); //获取上传表单（文件）
        //     file_form.append("file", file);
        //     importFile(e).then(() => {});
        // }
        getStyle() {
            return 'width: 130px; text-align: right'
        },
        getStyle2() {
            return 'width: 425.5px;'
        }
    },
};
</script>

<style lang="scss" scoped>
.tab_style {
    min-height: 40vh;
}
</style>
